import {PRICE_DURATIONS} from "~/constants/price_durations"
import {ELECTRICS} from "~/constants"

const pricingMatrixHeaderMap = (label: string): string => {
  switch (label) {
    case PRICE_DURATIONS.NIGHTLY:
      return 'Nightly'
    case PRICE_DURATIONS.NIGHTLY_2_PLUS:
      return 'Nightly 2 Plus'
    case PRICE_DURATIONS.NIGHTLY_3_PLUS:
      return 'Nightly 3 Plus'
    case PRICE_DURATIONS.WEEKLY:
      return 'Weekly'
    case PRICE_DURATIONS.MONTHLY:
      return 'Monthly'
    case PRICE_DURATIONS.FLAT_RATE:
      return 'Flat Rate'
    case PRICE_DURATIONS.SEASONAL:
      return 'Seasonal'
    default:
      return 'Nightly'
  }
}

const pricingMatricElectricLabelMap = (label: string): string => {
  switch (label) {
    case ELECTRICS.NONE:
      return 'None'
    case ELECTRICS.BASIC:
      return 'Basic'
    case ELECTRICS.E15:
      return '15A'
    case ELECTRICS.E20:
      return '20A'
    case ELECTRICS.E30:
      return '30A'
    case ELECTRICS.E50:
      return '50A'
    case ELECTRICS.SPLIT_15_30:
      return '15/30A'
    case ELECTRICS.SPLIT_20_30:
      return '20/30A'
    case ELECTRICS.SPLIT_30_50:
      return '30/50A'
    case ELECTRICS.SPLIT_15_30_50:
      return '15/30/50A'
    case ELECTRICS.SPLIT_20_30_50:
      return '20/30/50A'
    default:
      return ''
  }
}

const DURATION_ORDER = [
  'flat-rate',
  '1d',
  '2d+',
  '3d+',
  '1w',
  '1m',
  'seasonal'
]

const ELECTRICS_ORDER = [
  'none',
  'basic',
  '15',
  '20',
  '30',
  '50',
  '15/30',
  '20/30',
  '30/50',
  '15/30/50',
  '20/30/50',
]


export { pricingMatrixHeaderMap, pricingMatricElectricLabelMap, ELECTRICS_ORDER, DURATION_ORDER }
